import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { languages } from "common/data/languages";
import { flags } from "utils/flags";

interface LanguagesFormProps {
  selected: any;
  setSelected: any;
}

const Wrapper = styled.div`
  width: 100%;
`;

const Text = styled.h2`
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 1.8rem;
`;

const LangsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 50px 42px;
`;

const Button = styled.button(({ selected }: { selected: boolean }) => ({
  marginRight: "20px",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  cursor: "pointer",
  border: "none",
  outline: selected ? `5px solid #7D02FA` : "none",
}));

const Icon = styled.img`
  width: 100%;
`;

const LanguagesForm = ({ selected, setSelected }: LanguagesFormProps) => {
  const { t } = useTranslation("forms");

  return (
    <Wrapper>
      <Text>{t("chooseLanguages")}</Text>
      <LangsWrapper>
        {languages.map((language, index) => (
          <Button
            key={language}
            selected={selected[language]}
            onClick={() => {
              setSelected((prevState: any) => ({
                ...prevState,
                [language]: !prevState[language],
              }));
            }}
          >
            <Icon src={flags[language]} />
          </Button>
        ))}
      </LangsWrapper>
    </Wrapper>
  );
};

export default LanguagesForm;
